import React from 'react';

const Error404 = () => {
  return (
    <div className="w-full min-h-screen flex justify-center items-center">
      <div className="text-center">
        <h1 className="font-['Fredoka_One',cursive] text-info text-[150px] mb-[40px]">Oops!</h1>
        <h2 className="font-semibold text-[33px] text-text-main mb-[15px]">Something went wrong here.</h2>
        <h3 className="text-[20px] text-text-main font-light">
          {'We\'re working on it and we\'ll get it fixedas soon possible.'}
        </h3>
      </div>
    </div>
  );
};

Error404.propTypes = {};

Error404.defaultProps = {};

export default Error404;
